import { render, staticRenderFns } from "./CallFeedbackModal.vue?vue&type=template&id=2c14bc44&"
import script from "./CallFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./CallFeedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./CallFeedbackModal.vue?vue&type=style&index=0&id=2c14bc44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports